import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { BrandMark } from "./BrandMark";

const links = [
  { to: "/zodiac", label: "Signs" },
  { to: "/learn", label: "Learn" },
  { to: "/about", label: "About" },
  { to: "/faq", label: "FAQ" },
];

export const NavHeader = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  // Close the mobile menu whenever the route changes.
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      data-testid="nav-header"
      className="fixed top-0 left-0 right-0 z-30 px-4 sm:px-6 py-4 sm:py-5 bg-cosmic-900/40 backdrop-blur-md border-b border-white/[0.04]"
    >
      <div className="max-w-5xl mx-auto flex items-center justify-between gap-4">
        <Link to="/">
          <BrandMark />
        </Link>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-7 text-[11px] uppercase tracking-[0.25em] text-slate-300">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.to.slice(1)}`}
              className={({ isActive }) =>
                `transition-colors ${isActive ? "text-stardust" : "hover:text-stardust"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/"
            data-testid="nav-cta"
            className="text-[10px] sm:text-[11px] uppercase tracking-[0.25em] bg-stardust text-cosmic-900 hover:bg-stardust-light transition-colors px-3 sm:px-4 py-2 rounded-md font-medium"
          >
            Read my sky
          </Link>
          <button
            type="button"
            data-testid="nav-mobile-toggle"
            aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
            className="md:hidden inline-flex items-center justify-center h-9 w-9 rounded-md border border-white/10 text-slate-300 hover:text-stardust hover:border-stardust/50 transition-colors"
          >
            {open ? <X className="h-4 w-4" /> : <Menu className="h-4 w-4" />}
          </button>
        </div>
      </div>

      {/* Mobile drawer */}
      {open && (
        <nav
          data-testid="nav-mobile-drawer"
          className="md:hidden mt-3 mx-2 rounded-lg border border-white/10 bg-cosmic-900/80 backdrop-blur-md p-2 flex flex-col text-[11px] uppercase tracking-[0.25em]"
        >
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-mobile-${l.to.slice(1)}`}
              className={({ isActive }) =>
                `px-3 py-3 rounded-md transition-colors ${
                  isActive
                    ? "text-stardust bg-stardust/[0.06]"
                    : "text-slate-300 hover:text-stardust hover:bg-white/[0.04]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
      )}
    </header>
  );
};
